<div class="modal">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <div class="title">
    <ng-container *ngIf="data.id === 2; else Other">
      合租模式清退风险高，请参考以下选购指南
    </ng-container>
    <ng-template #Other>合租模式有清退风险，请参考以下选购指南</ng-template>
  </div>
  <div class="detail" mat-dialog-content>
    <table>
      <tr>
        <th></th>
        <th>
          <div class="direction">
            <img src="../../../../assets/images/logo/popcorn.png" alt="" />
            <span>爆米花</span>
          </div>
        </th>
        <th>
          <div class="direction">
            <img src="../../../../assets/images/logo/jiegehao.png" alt="" />
            <span>借个号</span>
          </div>
        </th>
        <th>
          <div class="direction">
            <app-image [fileid]="data?.icon" [radius]="8"></app-image>
            <span>{{ data.name }}</span>
          </div>
        </th>
      </tr>
      <tr *ngFor="let data of list">
        <td>{{ data.item1 }}</td>
        <td>{{ data.item2 }}</td>
        <td>{{ data.item3 }}</td>
        <td>{{ data.item4 }}</td>
      </tr>
      <tr>
        <td></td>
        <td>
          <button mat-flat-button color="primary" (click)="buy(1)">购买</button>
        </td>
        <td>
          <button mat-flat-button color="primary" (click)="buy(2)">购买</button>
        </td>
        <td>
          <button
            mat-flat-button
            color="primary"
            (click)="buy(3)"
            [disabled]="data.id === -1"
          >
            <ng-container *ngIf="data.id === -1; else outStock"
              >缺货</ng-container
            >
            <ng-template #outStock>购买</ng-template>
          </button>
        </td>
      </tr>
    </table>
  </div>
</div>
